<span style="margin-left: 10px;" class="text-primary">
   <ng-template #popContent>
     <div [innerHTML]="contentpopover"></div>
   </ng-template>
    <i  triggers="mouseenter:mouseleave" container="body" [ngbPopover]="popContent" [popoverTitle]="titlePopover"  class="fa fa-question-circle"></i>
  </span>
